import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { useOfferPageContext } from 'pages/offer/context';
import { Logos } from 'pages/offer/consts';
import x5LogoIcon from 'shared/icons/x5-logo.svg';
import { LogoutButton } from 'shared/ui/logout-button';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './header.module.scss';
import { IconsBlock } from '.';

export type HeaderProps = PropsWithChildren & {
  className?: string;
};

/**
 * Header
 * @param className
 */
export const Header = ({ className }: HeaderProps) => {
  const {
    userData: { businessUnit },
  } = useOfferPageContext();

  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.both} className={cn(styles.header, className)}>
      <Spacing size={SpacingSize.small} direction={SpacingDirection.both} className={styles.icons}>
        <img className={styles.icon} src={x5LogoIcon} />
        <img className={styles.businessUnitIcon} src={Logos[businessUnit.id]} />
      </Spacing>

      <div>
        <div className={styles.logoutButton}>
          <LogoutButton />
        </div>
        <IconsBlock />
      </div>
    </Spacing>
  );
};
